module.exports = __webpack_public_path__ + "img/3.50c9895496.png";